import ArcButton from 'app/components/arc/ArcButton';
import ArcDatePicker, {ArcDatePickerResult} from 'app/components/arc/ArcDatePicker';
import ArcInput from 'app/components/arc/ArcInput'
import ArcTextArea from 'app/components/arc/ArcTextArea';
import AppAlert from 'app/components/common/AppAlert';
import {closeModal, ModalProps, openModal} from 'app/reducers/modalSlice';
import {useAppDispatch} from 'app/store/hook';
import moment from 'moment';
import React, {useEffect, useState} from 'react'
import {SchdService} from "../../../../services/wp/SchdService";
import {ResponseResultCode} from "../../../../model/response-api";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";

export class Schedule {
  schdId?: string;
  schdYmd?: string;
  schdNm?: string | "";
  schdExpl?: string | "";

  constructor() {
    this.schdId = "";
    this.schdYmd = moment().format('YYYYMMDD');
    this.schdNm = "";
    this.schdExpl = "";
  }
}

export default function AddSche(props: Readonly<ModalProps>) {
  const [form, setForm] = useState<Schedule>(new Schedule());
  const [mode, setMode] = useState<string>(props.data?.mode ?? 'C');
  const [selectMm, setSelectMm] = useState(moment(new Date(props.data.date)).format('YYYYMMDD'));
  const dispatch = useAppDispatch();
  const {t} = useTranslation();

  function handleChange(e: any, name: string) {
    setForm({
      ...form,
      [name]: e,
    });
  }

  function changeDateSearch(result: ArcDatePickerResult): void {
    const {fromDateString} = result;
    if (fromDateString) {
      const fromDt = moment(fromDateString).format('YYYYMMDD');
      setSelectMm(fromDateString);
      setForm((prevState: any) => {
        return {
          ...prevState,
          schdYmd: fromDt
        };
      });
    }
  }

  const handleSubmit = () => {
    dispatch(
      openModal({
        path: "/cp/db/save",
        target: AppAlert,
        wrapStyle: {width: "20rem"},
        confirmProps: {
          type: "save",
          title: "저장하시겠습니까?",
          onConfirm: saveForm,
        },
      })
    );
  };

  const handleDelete = () => {
    dispatch(
        openModal({
          path: "/cp/db/delete",
          target: AppAlert,
          wrapStyle: {width: "20rem"},
          confirmProps: {
            type: "delete",
            title: "삭제하시겠습니까?",
            onConfirm: deleteForm,
          },
        })
    );
  };

  async function saveForm() {
    SchdService.getInstance().save(form).then(response => {
      if (response) {
        if (ResponseResultCode.Y === response.resultCode) {
          props.onClose(response.data);
          toast.success(t("common.message.success.save", {title: ""}));
        } else {
          toast.error(t("common.message.error.save", {title: ""}));
        }
      } else {
        toast.error(t("common.message.error.system"));
      }
      dispatch(closeModal());
    });
  }

  useEffect(() => {
    setSelectMm(moment(new Date(props.data.date)).format('YYYYMMDD'));
    setForm({...form, schdYmd: moment(new Date(props.data.date)).format('YYYYMMDD')});
    if (Object.keys(props.data.event).length != 0) {
      setForm(props.data.event);
    }
  }, []);

  function cancelBtn() {
    dispatch(closeModal());
  }

  function deleteForm() {
    SchdService.getInstance().deleteById({schdId: form.schdId}).then(response => {
      if (response) {
        if (ResponseResultCode.Y === response.resultCode) {
          props.onClose(response.data);
          toast.success(t("common.message.success.delete", {title: ""}));
        } else {
          toast.error(t("common.message.error.delete", {title: ""}));
        }
      } else {
        toast.error(t("common.message.error.system"));
      }
      dispatch(closeModal());
    });
  }

  return (
    <>
      {mode === 'C' && (
          <div className="layer-cont">
            <div className="flexWrap">
              <h3 className="titT1">일정 등록</h3>
            </div>
            <div className="border-box" style={{display: 'flex', flexDirection: 'column'}}>
              <div style={{padding: '0 0 0.5rem 0', borderBottom: '1px solid #3BBBCA'}}>
                <ArcDatePicker
                    onChange={(result: ArcDatePickerResult) => changeDateSearch(result)}
                    fromDate={selectMm}
                    id="date"
                    name="date"
                    minMaxDateMode="force"
                />
              </div>
              <div style={{padding: '0.5rem 0', borderBottom: '1px solid #ccc'}}>
                <ArcInput
                    value={(form.schdNm ?? "").toString()}
                    id="detail"
                    className="disIb"
                    onChange={({value, name, isValid}) => handleChange(value, 'schdNm')}
                    maxLength={60}
                    placeholder="제목을 입력하세요"
                    title="일정 제목"
                />
              </div>
              <div style={{padding: '0.5rem 0 0 0'}}>
                <ArcTextArea
                    onChange={({value, name, isValid}) => handleChange(value, 'schdExpl')}
                    id="detail"
                    name="detail"
                    value={form?.schdExpl || ""}
                    maxLength={100}
                    placeholder="내용을 입력하세요"
                    title="일정 내용"
                />
              </div>
            </div>
            <div className="btns ac">
              <ArcButton type={"cancel"} onClick={cancelBtn} />
              <ArcButton type={"save"} hasIcon={false} onClick={handleSubmit} />
            </div>
          </div>
      )}
      {mode === 'V' && (
          <div className="layer-cont">
            <div className="flexWrap">
              <h3 className="titT1">일정 상세</h3>
              <span className="l-ft1">{moment(selectMm).format('YYYY.MM.DD')}</span>
            </div>
            <div className="border-box">
              <div className="txt-break4" style={{padding: '0.5rem 0 0 0', borderTop: '1px solid #3BBBCA'}}>
                <p className="tit">{form.schdNm}</p>
                <p className="txt" style={{whiteSpace: 'pre'}}>{form?.schdExpl ?? ''}</p>
              </div>
            </div>
            <div className="btns ac">
              <ArcButton type="cancel" onClick={cancelBtn} text="취소" />
              <ArcButton type="delete" onClick={()=> {handleDelete()}} />
              <ArcButton type="modify" color="btn-style2" hasIcon={false} onClick={() => setMode('C')} />
            </div>
          </div>
      )}
    </>
  );
}
